import { BareButton } from '@calendly/ui/components/bare-button';
import { Loader } from '@calendly/ui/components/loader';
import { BodyText } from '@calendly/ui/components/typography';
import { truncateText } from '../utils';
const linkBadgeContainerCss = "lhsjomm";
const leftElementContainerCss = "ld1pcul";

/**
 * LinkBadge component displays a badge-like element with optional left element and text content.
 *
 * This component renders a rounded badge that can contain a left element (like an avatar or icon)
 * and text content. It's designed to display contact information, tags, or other badge-like UI elements.
 *
 * @param {Object} props - Component props
 * @param {string} props.text - The text content to display in the badge
 * @param {React.ReactNode} [props.leftElement] - Optional element to display on the left side of the text
 * @param {Function} [props.onClick] - Optional click handler for the badge
 * @param {boolean} [props.isLoading] - Optional loading state for the badge
 * @param {boolean} [props.disabled] - Optional disabled state for the badge
 *
 * @returns {JSX.Element} A badge component with optional left element and text
 *
 * @example
 * ```jsx
 * // Simple text badge
 * <LinkBadge text="Coffee Chat" />
 *
 * // Badge with avatar
 * <LinkBadge
 *   text="Coffee Chat"
 *   leftElement={<CalendarIcon />}
 *   onClick={() => {}}
 * />
 *
 * // Disabled badge
 * <LinkBadge
 *   text="Coffee Chat"
 *   disabled
 * />
 * ```
 */

export const LinkBadge = ({
  text,
  leftElement,
  onClick,
  isLoading,
  disabled
}) => {
  if (isLoading) {
    return <div className={linkBadgeContainerCss}>
        <Loader size="small" />
      </div>;
  }
  const displayText = truncateText(text);
  return <BareButton className={linkBadgeContainerCss} onClick={onClick} disabled={disabled}>
      {leftElement && <div className={leftElementContainerCss} data-testid="left-element-container">
          {leftElement}
        </div>}
      <BodyText size="medium" weight="semibold" color={disabled ? 'muted' : 'standard'}>
        {displayText}
      </BodyText>
    </BareButton>;
};

require("./LinkBadge.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./LinkBadge.js");